/*
 *  IRIS Interactive
 *
 *  NOTICE OF LICENSE
 *  This source file is no subject to a specific license
 *  but it belongs to the company IRIS Interactive.
 *  You can contact IRIS Interactive at the following
 *  address: contact@iris-interactive.fr
 *
 *  @author      Lucas Roche
 *  @date        25/06/2021 11:39
 *  @copyright   Copyright (c) 2002-2021 IRIS Interactive, Inc. (http://www.iris-interactive.fr)
 */

import {
    getCookie,
    setCookie,
} from '@iris.interactive/handcook/public/scripts/support/cookie.support'
import {
    MODAL_ID_CONTENT_IS_HELPFULL,
    MODAL_ID_CONTENT_IS_NOT_HELPFULL,
} from '../enumerators/content-helpfull-you.enum'
import { SUCCESS_EVENT } from '../enumerators/form.enum'

export default class ContentHelpfulYouComponent {
    tooltipHelpful
    tooltipNotHelpful
    previousVote

    constructor() {
        if (document.querySelectorAll('[data-trigger="this-content-is-helpful"]').length > 0) {
            import(
                /* webpackChunkName: "scripts/hc_tooltip" */
                /* webpackMode: "weak" */
                '@iris.interactive/handcook/public/scripts/components/tooltip/tooltip.component'
            ).then(({ default: hc_tooltip }) => {
                /* global IRISCollectionTheme */
                this.setPreviousVote()
                const btnIsHelpful = '[data-trigger="this-content-is-helpful"] i'
                const btnIsNotHelpful = '[data-trigger="this-content-is-not-helpful"] i'

                this.tooltipHelpful = hc_tooltip('[data-trigger="this-content-is-helpful"]', {
                    content: IRISCollectionTheme.contentHelpfull.translate.helpfull,
                })
                if (this.previousVote === 0 || this.previousVote === -1) {
                    this.tooltipHelpful.disable()
                }

                this.tooltipNotHelpful = hc_tooltip(
                    '[data-trigger="this-content-is-not-helpful"]',
                    {
                        content: IRISCollectionTheme.contentHelpfull.translate.useless,
                    },
                )
                if (this.previousVote === 1 || this.previousVote === -1) {
                    this.tooltipNotHelpful.disable()
                }

                /*
                 * Après la soumission du formulaire "ce contenu ne nous a pas été utile",
                 * si pas d'erreur on ferme la modal
                 */
                $(document).on(SUCCESS_EVENT, (event, form) => {
                    const formId = Number.parseInt($(form).find('input[name="form_id"]').val())
                })

                /*
                 * Dans le cas ou on a cliqué sur "ce contenu ne nous a pas été utile"
                 * On envoie la réponse au serveur et on ouvre la modal si ok sinon on affiche un notification
                 */
                $('[data-trigger="this-content-is-not-helpful"]').on('click', (e) => {
                    e.preventDefault()
                    this.setPreviousVote()

                    // Empêche de voter deux fois de suite (tant qu'on a un vote en cookie)
                    if (this.previousVote !== 0) {
                        fetch(IRISCollectionTheme.contentHelpfull.thisContentIsHelpfull, {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                            },
                            body: JSON.stringify({
                                queriedObject: IRISCollectionTheme.queriedObject,
                                isHelpful: 0,
                                previousVote: this.previousVote,
                            }),
                        })
                            .then((response) => {
                                if (!response.ok) {
                                    throw new Error('Network response was not ok')
                                }
                                // Success response
                                $(btnIsNotHelpful).addClass('ficore--thumb-down-full')
                                $(btnIsNotHelpful).removeClass('ficore--thumb-down')
                                $(btnIsHelpful).removeClass('ficore--thumb-up-full')
                                $(btnIsHelpful).addClass('ficore--thumb-up')
                                this.tooltipNotHelpful.enable()
                                this.tooltipHelpful.disable()

                                setCookie(IRISCollectionTheme.cookieNameOfHelpfulPreviousVote, 0, 7)

                                import(
                                    /* webpackChunkName: "scripts/hc_modal" */
                                    /* webpackMode: "weak" */
                                    '@iris.interactive/handcook/public/scripts/components/modal/modal.component'
                                ).then(({ HcModal }) => {
                                    HcModal.show({
                                        src: `#${MODAL_ID_CONTENT_IS_NOT_HELPFULL}`,
                                        autoFocus: false,
                                    })
                                })
                            })
                            .catch((error) => {
                                // Handle errors
                                const message = IRISCollectionTheme.contentHelpfull.translate.error
                                console.log(message, error)
                            })
                    }
                })

                /*
                 * Dans le cas ou on a cliqué sur "ce contenu nous a été utile"
                 * On envoie la réponse au serveur et on ouvre la modal si ok sinon on affiche un notification
                 */
                $('[data-trigger="this-content-is-helpful"]').on('click', (e) => {
                    e.preventDefault()
                    this.setPreviousVote()

                    // Empêche de voter deux fois de suite (tant qu'on a un vote en cookie)
                    if (this.previousVote !== 1) {
                        fetch(IRISCollectionTheme.contentHelpfull.thisContentIsHelpfull, {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                            },
                            body: JSON.stringify({
                                queriedObject: IRISCollectionTheme.queriedObject,
                                isHelpful: 1,
                                previousVote: this.previousVote,
                            }),
                        })
                            .then((response) => {
                                if (!response.ok) {
                                    throw new Error('Network response was not ok')
                                }

                                // Success response
                                $(btnIsHelpful).addClass('ficore--thumb-up-full')
                                $(btnIsHelpful).removeClass('ficore--thumb-up')
                                $(btnIsNotHelpful).removeClass('ficore--thumb-down-full')
                                $(btnIsNotHelpful).addClass('ficore--thumb-down')
                                this.tooltipNotHelpful.disable()

                                this.tooltipHelpful.enable()

                                setCookie(IRISCollectionTheme.cookieNameOfHelpfulPreviousVote, 1, 7)

                                import(
                                    /* webpackChunkName: "scripts/hc_modal" */
                                    /* webpackMode: "weak" */
                                    '@iris.interactive/handcook/public/scripts/components/modal/modal.component'
                                ).then(({ HcModal }) => {
                                    HcModal.show({
                                        src: `#${MODAL_ID_CONTENT_IS_HELPFULL}`,
                                    })
                                })
                            })
                            .catch((error) => {
                                // Handle errors
                                const message = IRISCollectionTheme.contentHelpfull.translate.error
                                console.log(message, error)
                            })
                    }
                })
            })
        }
    }

    setPreviousVote() {
        this.previousVote = Number.parseInt(
            getCookie(IRISCollectionTheme.cookieNameOfHelpfulPreviousVote),
        )
        this.previousVote = Number.isNaN(this.previousVote) ? -1 : this.previousVote
    }
}
